import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=0711e2a1&"
import script from "./ArticleTable.vue?vue&type=script&lang=js&"
export * from "./ArticleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports